<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.company.structure.lab.title') }}</h1>
    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.lab.content').split('---')[0]"></p>
        </div>
      </div>
      
      <!-- 图片部分 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="t('pages.company.structure.lab.other.picture1.url')" :alt="t('pages.company.structure.lab.other.picture1.alt')">
        </div>
      </div>
      
      <!-- 第二段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.lab.content').split('---')[1]"></p>
        </div>
      </div>
       <div class="content-section image-section">
        <div class="image-container">
          <img :src="t('pages.company.structure.lab.other.picture2.url')" :alt="t('pages.company.structure.lab.other.picture2.alt')">
        </div>
      </div>
      <!-- 可以根据需要添加更多的文字/图片部分 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.lab.content').split('---')[2]"></p>
        </div>
      </div>
<div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.lab.content').split('---')[3]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.lab.content').split('---')[4]"></p>
        </div>
      </div>
    
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped lang="scss">
/* 页面特定样式可以放在这里 */
</style> 